/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
/*jshint esversion: 11 */
require('./bootstrap');

import { createApp } from 'vue';

import FloatingVue from 'floating-vue';

import vSelect from 'vue-select';
//BMKFrameworkPlugin handles de lang integration.
//import {JSLang, trans, trans_choice} from '@common/tsutils/trans';
import VueFullscreen from 'vue-fullscreen';
import vfmPlugin from 'vue-final-modal';
import BmkFrameworkPlugin from '@biomemakers/bmk_ui_framework';

import RateCertificationViewMain from './components/Rate/vue/main.vue';

import gheom_main from './components/GHEOM/views/main.vue';
import GheomListView from './components/GHEOM/GheomListView.vue';
import ProductGrid from './components/GHEOM/ProductGrid.vue';
import SingleProduct from './components/GHEOM/SingleProduct.vue';
import SingleGheom from './components/GHEOM/SingleGheom.vue';
import TheBreadcrumbs from './components/GHEOM/TheBreadcrumbs.vue';
import GheomCard from './components/GHEOM/GheomCard.vue';
import GheomCard4Gheom from './components/GHEOM/GheomCard4Gheom.vue';
import CropsGrid from './components/GHEOM/CropsGrid.vue';
import TimeLine from './components/GHEOM/TimeLine.vue';
import OrphanCard from './components/GHEOM/OrphanCard.vue';
import ReportFootprint from './components/GHEOM/ReportFootprint.vue';
import GheomCheckboxes from './components/GHEOM/GheomCheckboxes.vue';
import CheckboxItem from './components/GHEOM/CheckboxItem.vue';
import GheomOverlay from './components/GHEOM/GheomOverlay.vue';
import CircleChart from './components/GHEOM/CircleChart.vue';
import GheomLoader from './components/GHEOM/GheomLoader.vue';
import GheomTooltip from './components/GHEOM/tooltip/GheomTooltip.vue';
import GheomTooltipLink from './components/GHEOM/tooltip/GheomTooltipLink.vue';
import GheomTooltipFunc from './components/GHEOM/tooltip/GheomTooltipFunc.vue';
import s3_main from './components/S3Files/main.vue';
import dashboard_main from './components/Dashboard/main.vue';
import unverified_main from './components/Unverified/main.vue';
import accept_terms_main from './components/AcceptUpgradedTerms/main.vue';
import sandbox_example_generator from './components/SandboxExampleGenerator/main.vue';
import dashboard_single from './components/DashboardSingle/DashboardView.vue';
import FarmsView from './components/Farms/FarmsView.vue';
import fastcheckout_main from './components/FastCheckout/main.vue';
import modal_navigator from './components/FastCheckout/modal_navigator.vue';
import order_table from './components/FastCheckout/order_table.vue';
import request_table from './components/FastCheckout/request_table.vue';
import invoice_table from './components/FastCheckout/invoice_table.vue';
import order_tables from './components/FastCheckout/order_tables.vue';
import paginator from './components/FastCheckout/paginator.vue';
import EasySelect from './components/EasySelect.vue';
import OrphanCTA from './components/Dashboard/Widgets/OrphanCTA.vue';
import PendingParcelsCTA from './components/Dashboard/Widgets/PendingParcelsCTA.vue';
import CropDistro from './components/Dashboard/Widgets/CropDistro.vue';
import Feed from './components/Dashboard/Widgets/Feed.vue';
import LastReports from './components/Dashboard/Widgets/LastReports.vue';
import DiseaseOverview from './components/Dashboard/Widgets/DiseaseOverview.vue';
import FertilizerOverview from './components/Dashboard/Widgets/FertilizerOverview.vue';
import ParcelsEffort from './components/Dashboard/Widgets/ParcelsEffort.vue';
import MainStats from './components/Dashboard/Widgets/MainStats.vue';
import Greetings from './components/Dashboard/Widgets/Greetings.vue';
import Leaderboard from './components/Dashboard/UI/Leaderboard.vue';
import Tabs from './components/Dashboard/UI/Tabs.vue';
import CircleButton from './components/Dashboard/UI/CircleButton.vue';
import GISTriggerWidget from './components/Dashboard/Widgets/GISTriggerWidget.vue';
import BarChart3D from './components/Dashboard/UI/BarChart3D.vue';
import SegmentChart from './components/Dashboard/UI/SegmentChart.vue';
import DonutProgress from './components/Dashboard/UI/DonutProgress.vue';
import List from './components/Dashboard/UI/List.vue';
import Select from './components/Dashboard/UI/Select.vue';
import Loader from './components/Dashboard/UI/Loader.vue';
import zero from './components/Dashboard/UI/zero.vue';
import MainViewMetricsBoxPlot from './components/Toolkit/MetricsBoxPlot/MainViewMetricsBoxPlot.vue';
import CooccurrenceView from './components/Toolkit/Cooccurrence/CooccurrenceView.vue';
import Heatmap2View from './components/Toolkit/Heatmap2/Heatmap2View.vue';
import ReportsView from './components/Reports/ReportsView.vue';
import GisUploaderView from './components/Tracking/GisUploader/GisUploaderView.vue';
import OpenIndicator from './components/Toolkit/Common/UI/OpenIndicator.vue';
import TrackingDashboard from './components/Tracking/Dashboard/TrackingDashboard.vue';
import ModuleSelector from './components/ModuleSelector/ModuleSelector.vue';
import ProposalsView from './components/Tracking/Proposals/ProposalsView.vue';
import AreaProjectResultsMap from './components/Results/AreaProjectMap/AreaProjectResultMap.vue';
import AreasList from './components/Results/Areas/AreasList.vue';
import ReportsList from './components/Results/Reports/ReportsList.vue';
import BlocksList from './components/Results/Blocks/BlocksList.vue';
import ProjectsEmbedView from './components/Results/Projects/ProjectsEmbedView.vue';
import SummaryTrialView from './components/Results/Projects/SummaryTrialView.vue';
import TrialsConfigurationView from './components/Tracking/Trials/TrackingTrialConfiguration/TrialsConfigurationView.vue';
import CompositionView from './components/Results/CompositionTool/CompositionView.vue';
import DistroToolView from './components/Results/DistroTool/DistroToolView.vue';
import TrialsSummary from './components/TrialsSummary/TrialsSummary.vue';
import AccessPanel from './components/Profile/Access/AccessPanel.vue';
import EBecropView from './components/EBecrop/EBecropView.vue';
import FieldsSetupFlow from './components/FieldsSetupFlow/FieldsSetupFlow.vue';
import MapSetupEconomic from './components/FieldsSetupFlow/views/EconomicSummaryStep.vue';
import ClientFarmListView from './components/ClientFarmListView/ClientFarmListView.vue';
import CustomQuoteView from './components/ClientFarmListView/CustomQuoteView.vue';
import FarmCRUDView from './components/ClientFarmListView/FarmCRUDView.vue';
import TabularAnalytics from './components/TabularAnalytics/TabularAnalytics.vue'

import 'vue-select/dist/vue-select.css';

require('../../../../node_modules/vis/dist/vis-timeline-graph2d.min.css');

const app = createApp({});

/*     vSelect.props.components.default = () => ({
        OpenIndicator: {
            render: (createElement) =>
                createElement('span', { class: { 'icon-anita-arrow_down': true } }),
        },
    }); */

vSelect.props.components.default = () => ({ OpenIndicator });

app.component('v-select', vSelect);

// window.Vue.http.headers.common['Access-Control-Request-Method'] = '*';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// ------------------------------------------------------------------------------ //
// PORTAL
// ------------------------------------------------------------------------------ //

// PROFILE

app.component('subclient-access', AccessPanel);

// Views

app.component('rate-certification-view-main', RateCertificationViewMain);

app.component('gheom-view-main', gheom_main);
app.component('gheom-list-view', GheomListView);
app.component('product-grid', ProductGrid);
app.component('single-product', SingleProduct);
app.component('single-gheom', SingleGheom);
app.component('breadcrumbs', TheBreadcrumbs);
app.component('gheom-card', GheomCard);
app.component('gheom-card-gheom', GheomCard4Gheom);
app.component('crops-grid', CropsGrid);
app.component('timeline', TimeLine);
app.component('orphan-card', OrphanCard);
app.component('report-footprint', ReportFootprint);
app.component('gheom-checkboxes', GheomCheckboxes);
app.component('checkbox-item', CheckboxItem);
app.component('gheom-overlay', GheomOverlay);
app.component('circle-chart', CircleChart);
app.component('gheom-loader', GheomLoader);
app.component('gheom-tooltip', GheomTooltip);
app.component('gheom-tooltip-link', GheomTooltipLink);
app.component('gheom-tooltip-func', GheomTooltipFunc);

app.component('s3files-view-main', s3_main);
app.component('unverified-main', unverified_main);
app.component('accept-upgraded-terms', accept_terms_main);
app.component('sandbox-example-generator', sandbox_example_generator);

app.component('dashboard-view-main', dashboard_main);
app.component('dashboard-single', dashboard_single);
app.component('fastcheckout-view-main', fastcheckout_main);
app.component('modal-navig', modal_navigator);
app.component('order-table', order_table);
app.component('request-table', request_table);
app.component('invoice-table', invoice_table);

app.component('order-tables', order_tables);
app.component('paginator', paginator);

app.component('easy-select', EasySelect);

// Dashboard widgets
app.component('orphan-cta', OrphanCTA);
app.component('pending-parcels-cta', PendingParcelsCTA);
app.component('crop-distro', CropDistro);
app.component('feed', Feed);
app.component('last-reports', LastReports);
app.component('disease-overview', DiseaseOverview);
app.component('fert-overview', FertilizerOverview);
app.component('parcels-effort', ParcelsEffort);
app.component('main-stats', MainStats);
app.component('greetings', Greetings);

// UI
app.component('leaderboard', Leaderboard);
app.component('tabs', Tabs);
app.component('bcw-button', CircleButton);
app.component('dasboard-widgets', GISTriggerWidget);

app.component('barchart-3d', BarChart3D);
app.component('segment-chart', SegmentChart);
app.component('donut-progress', DonutProgress);
app.component('list', List);
app.component('bcselect', Select);
app.component('loader', Loader);
app.component('zero', zero);

// Becrop Toolkit
app.component('toolkit-abundances-boxplot-view', require('./components/Toolkit/AbundancesBoxPlot/MainViewAbundancesBoxPlot.vue').default);
app.component('toolkit-metrics-boxplot-view', MainViewMetricsBoxPlot);
app.component('toolkit-cooccurrence-view', CooccurrenceView);
app.component('toolkit-heatmap2-view', Heatmap2View);

// Reports View
app.component('reports-view', ReportsView);
app.component('gisuploader-view', GisUploaderView);
app.component('tracking-trial-configuration', TrialsConfigurationView);
app.component('tracking-dashboard', TrackingDashboard);
app.component('module-selector-view', ModuleSelector);
app.component('proposals-view', ProposalsView);
app.component('projects-embed-view', ProjectsEmbedView);
app.component('results-view-map', AreaProjectResultsMap);
app.component('results-distro-tool', DistroToolView);
app.component('results-area-list', AreasList);
app.component('results-report-list', ReportsList);
app.component('results-view-parcel', BlocksList);
app.component('summary-trial-view', SummaryTrialView);
app.component('results-rate-composition-tool', CompositionView);
app.component('trials-summary', TrialsSummary);
app.component('tabular-analytics', TabularAnalytics);


//eBecrop
app.component('ebecrop-view', EBecropView);
app.component('farms-view', FarmsView)

//MAP SETUP ACTIVATION
app.component('map-setup-activation', FieldsSetupFlow);
app.component('client-farm-list', ClientFarmListView);
app.component('custom-quote-view', CustomQuoteView);
app.component('farm-crud', FarmCRUDView);

//V-popover

app.use(FloatingVue);

app.use(VueFullscreen);
app.use(vfmPlugin);

//console.log('hola!');

app.use(BmkFrameworkPlugin, { jslang_ts_interface: import('@common/tsutils/trans') });
window.app = app;

window.addEventListener('load', function () {
    app.mount('#vue-app');
});

/**
 * Other javascript files
 */
require('./utils/_utils');
// require('./utils/mixpanel.js');
require('./test_becrop');
